import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BaseModal } from 'src/app/core/models/classes/base-modal';
import { ModalService } from 'src/app/core/services/modal.service';

@Component({
  selector: 'app-add-import-farm',
  templateUrl: './add-import-farm.component.html',
  styleUrls: ['./add-import-farm.component.scss'],
})
export class AddImportFarmComponent extends BaseModal implements OnInit {
  @Input() id: number;
  constructor(private modalService: ModalService, private router: Router) {
    super();
    super._modalService=modalService;
   }

  ngOnInit() { 
    super.ngOnInit();
  }


  

  goToAddField() {
    this.modalService.dismissByModalId(this.id, null).then(e => {
      this.router.navigate(["/common/pair-device"]);
    });
  }

  goToImportField() {
    this.modalService.dismissByModalId(this.id, null).then(e => {
      this.router.navigate(["/common/pair-device"], { queryParams: { type: "import-field" } ,replaceUrl:true});
    });
  }
}
